import { storageKey, get, set, remove } from "./storage";
import { toast } from "./utils";

export { default as smoothScrollTop } from "./smoothScrollTop";

export const logout = (tips, type) => {
  remove(storageKey.userInfo);
  toast({ msg: tips || "已退出登录", severity: type || "success" });
}

export const login = (data) => {
  set(storageKey.userInfo, data);
}

export const getToken = () => {
  const userInfo = get(storageKey.userInfo);
  return userInfo?.token;
}
